export const PaddingDirection = {
    LEFT: 'PaddingDirection.LEFT',
    RIGHT: 'PaddingDirection.RIGHT',
    TOP: 'PaddingDirection.TOP',
    BOTTOM: 'PaddingDirection.BOTTOM',
    PADDING: 'PaddingDirection.PADDING',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const paddingDirectionValues = [...Object.values(PaddingDirection)] as const;
export type PaddingDirectionType = typeof paddingDirectionValues[number];

export const PADDING_DIRECTION_CLASSES: Record<PaddingDirectionType, string> = {
    [PaddingDirection.LEFT]: 'pl',
    [PaddingDirection.RIGHT]: 'pr',
    [PaddingDirection.TOP]: 'pt',
    [PaddingDirection.BOTTOM]: 'pb',
    [PaddingDirection.PADDING]: 'pad',
};

export const PaddingIndent = {
    NONE: '',
    XXS: 'PaddingIndent.XXS',
    XS: 'PaddingIndent.XS',
    S: 'PaddingIndent.S',
    SM: 'PaddingIndent.SM',
    M: 'PaddingIndent.M',
    L: 'PaddingIndent.L',
    XL: 'PaddingIndent.XL',
    XLS: 'PaddingIndent.XLS',
    XXL: 'PaddingIndent.XXL',
    XXXL: 'PaddingIndent.XXXL',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const paddingIndentValues = [...Object.values(PaddingIndent)] as const;
export type PaddingIndentType = typeof paddingIndentValues[number];

export const PADDING_INDENT_CLASSES: Record<PaddingIndentType, string> = {
    [PaddingIndent.NONE]: '',
    [PaddingIndent.XXS]: 'xxs',
    [PaddingIndent.XS]: 'xs',
    [PaddingIndent.S]: 's',
    [PaddingIndent.SM]: 'sm',
    [PaddingIndent.M]: 'm',
    [PaddingIndent.L]: 'l',
    [PaddingIndent.XL]: 'xl',
    [PaddingIndent.XLS]: 'xls',
    [PaddingIndent.XXL]: 'xxl',
    [PaddingIndent.XXXL]: 'xxxl',
};
